<template>
  <button class="final-quiz-item-component flex-column card px-5 mb-5">
    <div class="d-flex align-items-center py-5 w-100">
      <div class="d-flex align-items-center text-truncate flex-fill pl-3">
        <i class="fa-solid fa-file-pen lead text-primary pr-5"></i>
        <span class="title">{{ quiz.title }}</span>
        <span v-if="quiz.status === 'draft'" class="ml-5 draft-badge">
          Rascunho
        </span>
      </div>
      <div class="d-flex align-items-center justify-content-en">
        <div class="d-none d-sm-flex">
          <button
            class="btn btn-sm btn-new-secondary p-3 mr-3"
            @click.stop="onEdit"
            title="Editar"
          >
            <i class="fa-light fa-pen"></i>
          </button>
          <button
            class="btn btn-sm btn-new-secondary-danger p-3"
            @click.stop="removeConfirmation = true"
            title="Remover"
          >
            <i class="fa-light fa-trash"></i>
          </button>
        </div>
        <actions-dropdown
          class="d-sm-none"
          :left="false"
          :right="true"
          :actions="actions"
          @edit="onEdit"
          @remove="onRemove"
          toggleClass="p-0"
        >
          <template #button-custom-content>
            <i
              class="icon-more-vertical btn btn-sm pl-3 pl-md-5"
              role="button"
            ></i>
          </template>
        </actions-dropdown>
      </div>
    </div>
    <confirmation
      iconType="warning"
      title="Aviso"
      cancelButtonText="Cancelar"
      v-model="removeConfirmation"
      :newDesign="true"
      confirmButtonClass="btn-danger"
      confirmButtonText="Excluir"
      text="Tem certeza que deseja excluir a avaliação final?"
      @confirm="onRemove"
      @cancel="() => (removeConfirmation = false)"
    />
  </button>
</template>
<script>
export default {
  props: {
    quiz: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      removeConfirmation: false
    };
  },
  methods: {
    onEdit() {
      this.$router.push({
        name: "product-members-module-quizz-final-edit",
        params: { id: this.$route.params.id }
      });
    },
    onRemove() {
      this.$store
        .dispatch("membersQuizzes/deleteFinal", this.quiz.product_id)
        .then(() => {
          this.$emit("refresh");
          this.removeConfirmation = false;
          this.$message.success("A prova final foi excluída!");
        });
    }
  },
  computed: {
    actions() {
      return [
        {
          text: `Editar avaliação`,
          class: "",
          icon: "icon-filled-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: `Excluir avaliação`,
          class: "text-danger",
          icon: "icon-filled-trash",
          confirmation: {
            enable: true,
            text: "Tem certeza que deseja excluir essa avaliação?",
            newDesign: true,
            submitText: "Excluir",
            submitButtonClass: "btn-danger"
          },
          event: "remove"
        }
      ];
    }
  }
};
</script>
<style lang="scss" scoped>
.final-quiz-item-component {
  border: 1px solid var(--l-strokes-card, #d2d4df);
  background: var(--l-elevation-4, rgba(255, 255, 255, 0.16));
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
  width: 100%;
  .fa-file-pen {
    font-size: 14px;
  }

  .icon-drag-indicator {
    cursor: pointer;
    color: var(--l-neutral-15, rgba(184, 186, 204, 0.86));

    &:active {
      cursor: grap;
    }
  }

  .title {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
  }
  ::v-deep button.btn-square-sm,
  i.icon-more-vertical {
    padding: 16px 0 !important;
  }
}
</style>
